// handles fetching and caching images from a provider
export default function BgService(provider) {
    const pics = [];

    function next() {
        return new Promise((resolve, reject) => {
            if (pics.length === 0) {
                provider
                    .fetch()
                    .then(data => {
                        pics.push(...data);
                        resolve(pics.pop());
                    }, reject);
            } else {
                resolve(pics.pop());
            }
        });
    }

    return {
        next: next
    }
}
